import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext/AuthContext';

const NavAuthButtons = () => {
	const { currentUser, userRole } = useAuth();

	if (currentUser) {
		// User is logged in - show portal link
		const portalLink =
			userRole === 'employee' || userRole === 'admin'
				? '/portal/work'
				: '/portal/customer';

		return (
			<Button
				as={Link}
				to={portalLink}
				variant=''
				className='p-2 btn-cyv-teal'
				size='sm'>
				<i className='fa-sharp-duotone fa-thin fa-user'></i>{' '}
				<span className='fw-light'>My Portal</span>
			</Button>
		);
	}

	// THE TWO-DOOR DROPDOWN IS GONE (2026-08-20). It offered "Current System"
	// (MyMusicStaff) beside "New Portal (Dev)" behind a `showPortalLogin = false`
	// flag, so it never reached a browser — but it encoded a model that has since
	// been decided against, and a dead branch carrying a link to a retired route
	// is one flag flip from being live again. There is one door now.
	// ONE door, and it is the portal (Anthony, 2026-08-20). This used to point at
	// `/login` — the legacy MyMusicStaff widget page — which was the only login
	// a signed-out visitor could reach from this site. With no lessons left
	// scheduled in MMS, sending parents there during the onboarding push was
	// sending them to the wrong system at the exact moment they were being
	// taught the right one. `/login` now redirects here anyway (Members/Login.js),
	// so this link and that route agree.
	return (
		<>
			<Nav.Link as={Link} to='/portal/login' className='align-self-center'>
				<i className='fa-sharp-duotone fa-thin fa-arrow-right-to-bracket'></i>{' '}
				Login
			</Nav.Link>
			<Button
				as={Link}
				to='/contact'
				variant=''
				className='p-2 btn-cyv-ghost'
				size='sm'>
				<i className='fa-sharp-duotone fa-thin fa-user-plus'></i>{' '}
				<span className='fw-light'>Get Started</span>
			</Button>
		</>
	);
};

export default NavAuthButtons;
